import { render, staticRenderFns } from "./SimpleDialogComponent.vue?vue&type=template&id=3e6eb9c4&scoped=true&"
import script from "./SimpleDialogComponent.vue?vue&type=script&lang=js&"
export * from "./SimpleDialogComponent.vue?vue&type=script&lang=js&"
import style0 from "./SimpleDialogComponent.vue?vue&type=style&index=0&id=3e6eb9c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6eb9c4",
  null
  
)

export default component.exports